/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

const URL_BACKED_TARGETING_PATHS = [
  ['targeting', 'publisherTarget', 'earningsAccounts'],
  ['targeting', 'siteTarget', 'sites'],
  ['targeting', 'adUnitTarget', 'adUnits']
];

export function filterUrlLessTargeting(target: any): any {
  _.forEach(URL_BACKED_TARGETING_PATHS, (path) => {
    const values = _.get(target, path);
    if (_.isArray(values)) {
      _.set(target, path, _.filter(values, 'url'));
    }
  });
  return target;
}
